import { color, query, space } from '@design/templateFns';
import { FC } from 'react';
import styled from 'styled-components';

interface VerticalLineSeparatorProps {
  className?: string;
}

export const VerticalLineSeparator: FC<VerticalLineSeparatorProps> = (props) => {
  const { className } = props;
  return <VerticalHR className={className} />;
};

const VerticalHR = styled.hr`
  height: 120px;
  width: 0;
  display: block;
  position: relative;
  //This is the standardized margin above and below the line, refactor sibling elements to remove margins top and bottom
  margin: ${space('x6')} auto;
  border-width: 0 1px 0 0;
  border-style: solid;
  border-color: ${color('cta')};
  box-sizing: content-box;

  @media screen and (${query.below('desktop')}) {
    height: 105px;
    margin: ${space('x6')} auto;
  }

  @media screen and (${query.below('tablet')}) {
    height: 88px;
    margin: ${space('x5')} auto;
  }
`;
